import React, { useState, useContext, useEffect } from "react";
import { AppContext } from "../../../context/AppContext";
import ApiConfig from "../../../api/ApiConfig";
import '../../../assets/css/Pristan_Css/salary.scss'
import {
  PostCallWithAuthToken,
  PutCallWithAuthToken,
  putCallWithFormData,
  simpleGetCallWithToken,
} from "../../../api/ApiServices";
import { notifyError, notifySuccess } from "../../../toaster/notify";

import { Form } from "react-bootstrap";
import { BackDropLoader } from "../../../sharedComponent/BackDropLoader";
// import DatePicker from "react-date-picker";
// import { displayDateFormat } from "../../comman";
import useApiService from "../customHook/useApiService";
import moment from "moment";
// import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
// import editIcon from "../../assets/images/editIcon.svg";
import { Formik } from "formik";

const Settings = () => {
  const { get, post, put } = useApiService();
  const { sidebar, setbackdrop, userLoginData, setBackDropOpen, appSettings } =
    useContext(AppContext);
  // setting API
  const [documentsTypes, setDocumentsTypes] = useState([]);
  // const [entityLoader, setEntityLoader] = useState(false);
  const [validated, setValidated] = useState(false);
  const [isValidated, setIsValidated] = useState(false);
  useEffect(() => {
    getInvoiceTypes(userLoginData.clientId, userLoginData.clientEntityId);
    getGeneralSettings(userLoginData.clientId, userLoginData.clientEntityId);
    getGstSettings();
    getCompanyProfileData();
  }, []);

  const getInvoiceTypes = (clientId, entityId) => {
    simpleGetCallWithToken(
      `${ApiConfig.GET_INVOICE_TYPES}` //?clientId=${clientId}&entityId=${entityId}`
    )
      .then((res) => {
        if (res.success === true) {
          setDocumentsTypes(res.data);
          console.log("data--->", res.data);
        } else {
          console.log("error response,", res);
        }
      })
      .catch((err) => {
        console.log("getInvoiceTypes-error,", err);
      });
  };
  const [docTypeId, setDocTypeId] = useState("");

  const [docDetails, setDocDetails] = useState({
    voucherMasterId: 0,
    numberingMode: "",
    prefix: "",
    suffix: "",
    firstNumber: 0,
    counterLength: 0,
    clientEntityId: 0,
    //clientId: 0,
  });

  const getDocDetails = (docTypeId, ClientEntityId, ClientId) => {

    setbackdrop(true);
    simpleGetCallWithToken(
      `${ApiConfig.GET_DOCUMENT_DETAILS}?Id=${docTypeId}` //&ClientEntityId=${ClientEntityId}&ClientId=${ClientId}`
    )
      .then((res) => {
        setbackdrop(false);
        if (res.success === true) {


          let docDetailsObj = {
            voucherMasterId: Number(docTypeId),
            numberingMode: res.data.numberingType ? res.data.numberingType : "",
            prefix: res.data.typePrefix ? res.data.typePrefix : "",
            suffix: res.data.typeSuffix ? res.data.typeSuffix : "",
            firstNumber: res.data.firstNumber ? res.data.firstNumber : "",
            counterLength: res?.data.counterLength ? res?.data.counterLength : "",
            clientEntityId: parseInt(res?.data.clientEntityId)
              ? parseInt(res?.data.clientEntityId)
              : "",
            //clientId: parseInt(ClientId) ?,
          };
          setDocDetails(docDetailsObj);
        } else {
          setbackdrop(false);
          console.log("error response,", res);
        }
      })
      .catch((err) => {
        setbackdrop(false);
        console.log("getInvoiceTypes-error,", err);
      });
  };
const [lengthError, setLengthError] = useState("");

  const getTotalInvoiceLength = () => {
  const prefixLength = docDetails.prefix?.length || 0;
  const suffixLength = docDetails.suffix?.length || 0;
  const counterLength = Number(docDetails.counterLength?.length) || 0;
  return Number(prefixLength) + Number(suffixLength) + Number(counterLength);
};

  const updateInvoiceNumbering = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
const totalLength = getTotalInvoiceLength();
     if (totalLength > 16) {
    // setLengthError(
    //   `Prefix, Suffix and Counter Length combine cannot exceed 16 characters. Current length: ${totalLength}`
    // );

    notifyError(`Prefix, Suffix and Counter Length combine cannot exceed 16 characters. Current length: ${totalLength}`)
    setValidated(true);
    return;
  } else {
    setLengthError("");
  }
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      setBackDropOpen(true);
      PutCallWithAuthToken(
        ApiConfig.UPDATE_INVOICE_NUMBERING,
        JSON.stringify(docDetails)
      )
        .then((res) => {
          if (res.json?.success === true) {
            setValidated(false);
            notifySuccess(res.json.Message);
            setDocTypeId("");
            setDocDetails({
              voucherMasterId: 0,
              numberingMode: "",
              prefix: "",
              suffix: "",
              firstNumber: 0,
              counterLength: 0,
              clientEntityId: 0,
            });
          } else {
            notifyError(res?.json.message);
            console.log("error response", res);
          }
        })
        .catch((err) => {
          console.log("error response,", err);
        })
        .finally(() => {

          setBackDropOpen(false);
        });
    }
    setValidated(true);
  };

  // ======================= ========= GET_GENERAL_SETTINGS ============ ================================= //
  const [generalSettings, setGeneralSettings] = useState({
    id: 0,
    isDiscount: false,
    discType: "",
    isRoundOff: false,
    dateFormat: "",
    clientEntityId: 0,
    clientId: 0,
  });

  const getGeneralSettings = (clientId, entityId) => {
    simpleGetCallWithToken(
      `${ApiConfig.GET_GENERAL_SETTINGS}` //?clientId=${clientId}&entityId=${entityId}`
    )
      .then((res) => {
        if (res.success === true) {
          if (res.data !== null) {
            setGeneralSettings({ ...res.data, clientId: clientId });
          } else {
            setGeneralSettings({
              id: 0,
              isDiscount: false,
              discType: "",
              isRoundOff: false,
              dateFormat: "",
              clientEntityId: 0,
            });
          }
        } else {
          console.log("error res,", res);
        }
      })
      .catch((err) => {
        console.log("err,", err);
      });
  };

  const updateGenearalSettings = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      setBackDropOpen(true);
      PutCallWithAuthToken(
        ApiConfig.UPDATE_SETTINGS,
        JSON.stringify(generalSettings)
      )
        .then((res) => {
          if (res.json.Success === true) {
            localStorage.setItem("appSettings", JSON.stringify(res.json.data));
            notifySuccess(res.json.Message);
            setIsValidated(false);
          } else {
            console.log("error response,", res);
            notifyError(res.json.Message);
          }
        })
        .catch((err) => {
          console.log("error response,", err);
          notifyError(err.json.Message);
        })
        .finally(() => {
          setBackDropOpen(false);
        });
    }
    setIsValidated(true);
  };
  // ======================= ========= GET_GENERAL_SETTINGS ============ ================================= //

  // ===================================== GST SETTINGS ================================================== //
  const [einvioceData, setEinvioceData] = useState({
    id: 0,
    gstPortal: "e-invoice",
    username: "",
    password: "",
  });

  const [eWayBillData, setEWayBillData] = useState({
    id: 0,
    gstPortal: "e-waybill",
    username: "",
    password: "",
  });

  let isCredentialsFilled =
    (einvioceData.username && einvioceData.password) ||
      (eWayBillData.username && eWayBillData.password)
      ? false
      : true;

  const getGstSettings = () => {
    setBackDropOpen(true);
    simpleGetCallWithToken(ApiConfig.GET_GST_SETTING)
      .then((res) => {
        if (res.success) {
          let eInvoiceObj = res?.data[0];
          let eInvoiceData = {
            id: eInvoiceObj.id ? eInvoiceObj.id : 0,
            gstPortal: eInvoiceObj.gstPortal ? eInvoiceObj.gstPortal : "",
            username: eInvoiceObj.username ? eInvoiceObj.username : "",
            password: eInvoiceObj.password ? eInvoiceObj.password : "",
          };
          setEinvioceData(eInvoiceData);

          let eWayBillObj = res?.data[1];
          let eWayBillData = {
            id: eWayBillObj.id ? eWayBillObj.id : 0,
            gstPortal: eWayBillObj.gstPortal ? eWayBillObj.gstPortal : "",
            username: eWayBillObj.username ? eWayBillObj.username : "",
            password: eWayBillObj.password ? eWayBillObj.password : "",
          };
          setEWayBillData(eWayBillData);
          setBackDropOpen(false);
        } else {
          console.log("error response", res);
        }
      })
      .catch((error) => {
        console.log("catch error response", error);
      })
      .finally(() => {
        setBackDropOpen(false);
      });
  };

  const saveGSTSettings = (event) => {
    event.preventDefault();
    if (isCredentialsFilled) {
      notifyError("Please Enter Credentials");
    } else {
      setBackDropOpen(true);
      let mergedArr = [einvioceData, eWayBillData];
      let payLoad = {
        gstCredentials: mergedArr,
      };
      PostCallWithAuthToken(ApiConfig.ADD_GST_SETTINGS, JSON.stringify(payLoad))
        .then((res) => {
          if (res.json.success === true) {
            notifySuccess("GST settings saved successfully");
          } else {
            console.log("error response,", res);
          }
        })
        .catch((error) => {
          console.log("catch error response,", error);
        })
        .finally(() => {
          setBackDropOpen(false);
        });
    }
    setValidated(true);
  };
  // ===================================== GST SETTINGS ================================================== //

  // ===================================== PROFILE SETTINGS ================================================== //
  const [entityDetails, setEntityDetails] = useState({
    entityName: "",
    email: "",
    gstNo: "",
    address: "",
    additionalAddress: "",
    city: "",
    pinCode: "",
    contactNo: "",
    compLogo: "",
    signature: "",
    terms: "",
    bankDetails: "",
  });
  const [isCountFulfiled, setIsCountFulfiled] = useState(false);
  useEffect(() => {
    entityDetails.terms.length === 250
      ? setIsCountFulfiled(true)
      : setIsCountFulfiled(false);
  }, [isCountFulfiled, entityDetails]);
  const getCompanyProfileData = () => {
    simpleGetCallWithToken(ApiConfig.GET_PROFILE_DETAILS)
      .then((res) => {
        if (res.success === true) {
          setEntityDetails({
            entityName: res.data?.entityName ? res.data?.entityName : "",
            email: res.data?.email ? res.data?.email : "",
            gstNo: res.data?.gstNo ? res.data?.gstNo : "",
            panNo: res.data?.panNo ? res.data?.panNo : "",
            address: res.data?.address ? res.data?.address : "",
            additionalAddress: res.data?.additionalAddress
              ? res.data?.additionalAddress
              : "",
            city: res.data?.city ? res.data?.city : "",
            pinCode: res.data?.pinCode ? res.data?.pinCode : "",
            contactNo: res.data?.contactNo ? res.data?.contactNo : "",
            compLogo: res.data?.compLogo ? res.data?.compLogo : "",
            signature: res.data?.signature ? res.data?.signature : "",
            terms: res.data?.terms ? res.data?.terms : "",
            bankDetails: res.data?.bankDetails ? res.data?.bankDetails : "",
          });
        }
      })
      .catch((err) => {
        console.log("error response :,", err);
      });
  };

  const onChangeHandler = (event) => {
    setEntityDetails({
      ...entityDetails,
      [event.target.name]: event.target.value,
    });
  };

  function getFormData(object) {
    const formData = new FormData();
    Object.keys(object).forEach((key) => formData.append(key, object[key]));
    return formData;
  }

  const updateCompanyProfile = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(true);
    } else {
      let entityDetailsFormData = getFormData(entityDetails);
      setBackDropOpen(true);
      putCallWithFormData(
        ApiConfig.UPDATE_COMPANY_PROFILE,
        entityDetailsFormData
      )
        .then((res) => {
          if (res.json.Success === true) {
            notifySuccess("Profile updated successfully");
          } else {
            console.log("error response,", res);
          }
        })
        .catch((err) => {
          console.log("error resonse,", err);
        })
        .finally(() => {
          setBackDropOpen(false);
        });
    }
  };

  // ===================================== FINANCIAL YEAR SETTINGS ================================================== //
  const [yearModalOpen, setYearModalOpen] = useState(false);

  const [existingData, setExistingData] = useState({
    name: "",
    startDate: "",
    endDate: "",
    isCurrentYear: false,
  });
  const [financialYearList, setFinancialYearList] = useState([]);

  useEffect(() => {
    fetchYearList();
  }, []);

  const fetchYearList = async () => {
    try {
      const res = await get(ApiConfig.FETCH_FINANCIAL_YEAR_LIST);
      const { statusCode, data, success } = res;
      if (statusCode == 200 && success) {
        setFinancialYearList(data);
      }
    } catch (error) {
      console.error("Error fetching financial year list:", error);
    }
  };
  // ===================================== FINANCIAL YEAR SETTINGS ================================================== //

  return (
    <>
      <div
        className={sidebar ? "SalesGoods-main " : "cx-active SalesGoods-main"}
        id="cx-main"
      >
        {/* <BackDropLoader
          backDropOpen={backDropOpen}
          setBackDropOpen={setBackDropOpen}
        /> */}
        <div className="mainSettings">
          <Form
            noValidate
            validated={validated}
            onSubmit={updateInvoiceNumbering}
          >
            <div className="mainCard">
              <div className="cardHead">
                <label htmlFor="">Invoice Numbering</label>
              </div>
              <div className="cardBody">
                <div className="row mb-2">
                  <div className="col-md-6 col-sm-12">
                    <div className="form-group mainForm">
                      <label htmlFor="" className="txtLabel">
                        Document Type
                      </label>
                      <select
                        className="form-select important-form-select-for-priston-dd"
                        aria-label="Default select example"
                        // value={docTypeId ? docTypeId : ""}
                        onClick={(e) => {
                          setDocTypeId(e.target.value);
                          e.target.value &&
                            getDocDetails(
                              e.target.value,
                              userLoginData.clientEntityId,
                              userLoginData.clientId
                            );
                        }}
                        required
                      >
                        <option value="">Select type of Invoice</option>
                        {documentsTypes.map((item, i) => {
                          return (
                            <option key={"documentsTypes" + i} value={item.id}>
                              {item.name}
                            </option>
                          );
                        })}
                      </select>
                      <div className="invalid-feedback">
                        Please select invoice type
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <div className="form-group mainForm">
                      <label htmlFor="" className="txtLabel">
                        Numbering Type
                      </label>
                      <select
                        className="form-select important-form-select-for-priston-dd"
                        aria-label="Default select example"
                        value={
                          docDetails.numberingMode
                            ? docDetails.numberingMode
                            : ""
                        }
                        onChange={(e) => {
                          setDocDetails({
                            ...docDetails,
                            numberingMode: e.target.value,
                          });
                        }}
                        required
                      >
                        <option value="">Select type...</option>
                        <option value="AUTO">AUTO</option>
                        <option value="MANUAL">MANUAL</option>
                      </select>
                      <div className="invalid-feedback">
                        Please select numbering type
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <div className="mainForm">
                      <label htmlFor="" className="txtLabel">
                        Prefix
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="INV-000001"
                        value={docDetails.prefix ? docDetails.prefix : ""}
                        onChange={(e) => {
                          setDocDetails({
                            ...docDetails,
                            prefix: e.target.value.toUpperCase(),
                          });
                        }}
                        required
                      />
                      <div className="invalid-feedback">
                        Please enter prefix
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <div className="mainForm">
                      <label htmlFor="" className="txtLabel">
                        Suffix
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="000001-INV"
                        value={docDetails.suffix ? docDetails.suffix : ""}
                        onChange={(e) => {
                          setDocDetails({
                            ...docDetails,
                            suffix: e.target.value.toUpperCase(),
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <div className="mainForm">
                      <label htmlFor="" className="txtLabel">
                        First Number
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={
                          docDetails.firstNumber ? docDetails.firstNumber : ""
                        }
                        onChange={(e) => {
                          setDocDetails({
                            ...docDetails,
                            firstNumber: Number(e.target.value),
                          });
                        }}
                        required
                      />
                      <div className="invalid-feedback">
                        Please enter first number
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <div className="mainForm">
                      <label htmlFor="" className="txtLabel">
                        Counter Length
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        value={
                          docDetails.counterLength
                            ? docDetails.counterLength
                            : ""
                        }
                        onChange={(e) => {
                          setDocDetails({
                            ...docDetails,
                            counterLength: e.target.value,
                          });
                        }}
                        required
                      />
                      {/* <div
  className={`small mt-1 ${
    getTotalInvoiceLength() > 16 ? "text-danger" : "text-muted"
  }`}
>
  Total Length: {getTotalInvoiceLength()} / 16
</div> */}
                      <div className="invalid-feedback">
                        Please enter counter length
                      </div>
                      {lengthError && (
  <div className="text-danger mt-1" style={{fontSize:'10px'}}>
    {lengthError}
  </div>
)}
                    </div>
                  </div>
                </div>
                <div className="col-lg-12 text-end responiWidth" style={{ marginTop: "20px" }}>
                  <button
                    type="button"
                    className="cancel-btn"
                    onClick={(e) => {
                      e.preventDefault();
                      setDocDetails({
                        voucherMasterId: 0,
                        numberingMode: "",
                        prefix: "",
                        suffix: "",
                        firstNumber: 0,
                        counterLength: 0,
                        clientEntityId: 0,
                      });
                    }}
                  >
                    Cancel
                  </button>

                  <button
                    type="submit"
                    className="save-btn pl-2 pr-2"
                    id="widthauto"        // FIXED (removed #)
                    style={{ marginLeft: "10px" }} // ensures button spacing
                  >
                    Save
                  </button>
                </div>

              </div>
            </div>
          </Form>
          <div className="mainCard">
            <div className="cardHead">
              <label htmlFor="">General settings</label>
            </div>
            <div className="cardBody">
              <Form
                noValidate
                validated={isValidated}
                onSubmit={updateGenearalSettings}
              >
                <div className="row mb-2">
                  <div className="col-md-6 col-sm-12">
                    <div className="form-group mainForm">
                      <div className="justify-content-between d-flex">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <label htmlFor="" className="txtLabel">
                            Discount Type
                          </label>
                        </div>

                        <div>
                          <input
                            type="checkbox"
                            className="m-2"
                            id="selectDuscount"
                            checked={generalSettings?.isDiscount}
                            onChange={(e) => {
                              setGeneralSettings({
                                ...generalSettings,
                                isDiscount: e.target.checked,
                                discType: "",
                              });
                            }}
                          />
                          <label htmlFor="selectDuscount" className="txtLabel">
                            Enable Discount
                          </label>
                        </div>
                      </div>
                      <select
                        className="form-select important-form-select-for-priston-dd"
                        aria-label="Default select example"
                        disabled={!generalSettings?.isDiscount ? true : false}
                        value={generalSettings?.discType}
                        onChange={(e) => {
                          setGeneralSettings({
                            ...generalSettings,
                            discType: e.target.value,
                          });
                        }}
                        required={generalSettings?.isDiscount ? true : false}
                      >
                        <option value="">Select Discount Type...</option>
                        <option value="Percent">Percent</option>
                        <option value="Amount">Amount</option>
                        {/* <option value="None">None</option> */}
                      </select>
                      <div className="invalid-feedback">
                        Please select discount type
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 col-sm-12">
                    <div className="form-group mainForm">
                      <label htmlFor="" className="txtLabel">
                        Choose Date Format
                      </label>
                      <select
                        required
                        className="form-select important-form-select-for-priston-dd"
                        aria-label="Default select example"
                        value={generalSettings?.dateFormat}
                        onChange={(e) => {
                          setGeneralSettings({
                            ...generalSettings,
                            dateFormat: e.target.value,
                          });
                        }}
                      >
                        <option value="">Select Date Format...</option>
                        <option value="MM/dd/yyyy">MM/dd/yyyy</option>
                        <option value="dd/MM/yyyy">dd/MM/yyyy</option>
                        <option value="yyyy/MM/dd">yyyy/MM/dd</option>
                      </select>
                      <div className="invalid-feedback">
                        Please select date format
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 col-sm-12">
                    <div className="form-group mainForm">
                      <label htmlFor="" className="txtLabel">
                        Choose Round off
                      </label>
                      <select
                        required
                        className="form-select important-form-select-for-priston-dd"
                        aria-label="Default select example"
                        value={generalSettings?.isRoundOff}
                        onChange={(e) => {
                          setGeneralSettings({
                            ...generalSettings,
                            isRoundOff:
                              e.target.value === "true" ? true : false,
                          });
                        }}
                      >
                        <option value="">Please Select...</option>
                        <option value={true}>Yes</option>
                        <option value={false}>No</option>
                      </select>
                      <div className="invalid-feedback">
                        Please select round off
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-12 text-end responiWidth">
                  <button
                    type="button"
                    className="cancel-btn"
                    onClick={(e) => {
                      e.preventDefault();
                      setDocDetails({
                        voucherMasterId: 0,
                        numberingMode: "",
                        prefix: "",
                        suffix: "",
                        firstNumber: 0,
                        counterLength: 0,
                        clientEntityId: 0,
                      });
                    }}
                  >
                    Cancel
                  </button>
                  <button className="save-btn  pl-2 pr-2" id="widthauto">
                    Save
                  </button>
                </div>
              </Form>
            </div>
          </div>

          {/* ========================================= GST SETTINGS ========================================= */}
          {appSettings && appSettings.isGSTApplicable && (
            <div className="mainCard">
              <div className="cardHead">
                <label htmlFor="">GST Settings</label>
              </div>
              <div className="cardBody">
                <Form
                  noValidate
                  validated={isValidated}
                  onSubmit={saveGSTSettings}
                >
                  <div className="row mb-2">
                    <div className="col-md-6 col-sm-12">
                      <div className="form-group mainForm">
                        <div className="justify-content-between d-flex">
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <label htmlFor="" className="txtLabel">
                              Do you have E-Invoice credentials ?
                            </label>
                          </div>
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter your email address"
                          value={
                            einvioceData.username ? einvioceData.username : ""
                          }
                          name="einvoiceEmail"
                          onChange={(e) => {
                            setEinvioceData({
                              ...einvioceData,
                              username: e.target.value,
                            });
                          }}
                        />
                        <div className="invalid-feedback">
                          Username is required
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 col-sm-12">
                      <div className="form-group mainForm">
                        <label
                          htmlFor=""
                          className="txtLabel"
                          style={{ visibility: "hidden" }}
                        >
                          Choose Date Format
                        </label>
                        <input
                          type="password"
                          className="form-control"
                          placeholder="Enter your Password"
                          value={
                            einvioceData.password ? einvioceData.password : ""
                          }
                          name="einvoiceName"
                          onChange={(e) => {
                            setEinvioceData({
                              ...einvioceData,
                              password: e.target.value,
                            });
                          }}
                        />
                        {/* <div className="invalid-feedback">
                        Please select date format
                      </div> */}
                      </div>
                    </div>

                    <div className="col-md-6 col-sm-12">
                      <div className="form-group mainForm">
                        <label htmlFor="" className="txtLabel">
                          Do you have E-Way Bill credentials ?
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter your email address"
                          value={
                            eWayBillData.username ? eWayBillData.username : ""
                          }
                          name="ewaybillEmail"
                          onChange={(e) => {
                            setEWayBillData({
                              ...eWayBillData,
                              username: e.target.value,
                            });
                          }}
                        />
                        {/* <div className="invalid-feedback">
                        Please select round off
                      </div> */}
                      </div>
                    </div>
                    <div className="col-md-6 col-sm-12">
                      <div className="form-group mainForm">
                        <label
                          htmlFor=""
                          className="txtLabel"
                          style={{ visibility: "hidden" }}
                        >
                          Choose Date Format
                        </label>
                        <input
                          type="password"
                          className="form-control"
                          placeholder="Enter your Password"
                          value={
                            eWayBillData.password ? eWayBillData.password : ""
                          }
                          name="ewaybillName"
                          onChange={(e) => {
                            setEWayBillData({
                              ...eWayBillData,
                              password: e.target.value,
                            });
                          }}
                        />
                        {/* <div className="invalid-feedback">
                        Please select round off
                      </div> */}
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-12 text-end responiWidth">
                    <button
                      type="button"
                      className="cancel-btn"
                      onClick={(e) => {
                        e.preventDefault();
                        setDocDetails({
                          voucherMasterId: 0,
                          numberingMode: "",
                          prefix: "",
                          suffix: "",
                          firstNumber: 0,
                          counterLength: 0,
                          clientEntityId: 0,
                        });
                      }}
                    >
                      Cancel
                    </button>
                    <button className="save-btn  pl-2 pr-2" id="widthauto">
                      Save
                    </button>
                  </div>
                </Form>
              </div>
            </div>
          )}
          {/* ========================================= GST SETTINGS ========================================= */}

          {/* ========================================= PROFILE SETTINGS ========================================= */}
          <div className="mainCard">
            <div className="cardHead">
              <label htmlFor="">Profile Settings</label>
            </div>
            <div className="cardBody">
              <Form
                noValidate
                validated={validated}
                onSubmit={updateCompanyProfile}
              >
                <div className="row mb-2">
                  <div className="col-md-6 col-sm-12">
                    <div className="form-group mainForm">
                      <div className="justify-content-between d-flex">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <label htmlFor="" className="txtLabel">
                            Entity Name
                          </label>
                        </div>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter your entity name"
                        name="entityName"
                        onChange={onChangeHandler}
                        value={
                          entityDetails.entityName
                            ? entityDetails.entityName
                            : ""
                        }
                        required
                      />
                      <div className="invalid-feedback">
                        Entity Name is required
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 col-sm-12">
                    <div className="form-group mainForm">
                      <label htmlFor="" className="txtLabel">
                        What is your email?
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleFormControlInput2"
                        placeholder="Enter your email"
                        name="email"
                        value={entityDetails.email ? entityDetails.email : ""}
                        onChange={onChangeHandler}
                        required
                      />
                      <div
                        style={{ fontSize: "14px" }}
                        className="invalid-feedback"
                      >
                        Please Enter your valid email
                      </div>
                    </div>
                  </div>
                  {appSettings && appSettings.isGSTApplicable && (
                    <div className="col-md-6 col-sm-12">
                      <div className="form-group mainForm">
                        <label htmlFor="" className="txtLabel">
                          What is your GST No?
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter your GST No"
                          name="gstNo"
                          value={entityDetails.gstNo ? entityDetails.gstNo : ""}
                          onChange={onChangeHandler}
                          required
                        />
                        <div
                          style={{ fontSize: "14px" }}
                          className="invalid-feedback"
                        >
                          GST Number is required
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="col-md-6 col-sm-12">
                    <div className="form-group mainForm">
                      <label htmlFor="" className="txtLabel">
                        What is your PAN No?
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleFormControlInput5"
                        placeholder="Enter your PAN No"
                        name="panNo"
                        value={entityDetails.panNo ? entityDetails.panNo : ""}
                        onChange={onChangeHandler}
                      />
                      <div
                        style={{ fontSize: "14px" }}
                        className="invalid-feedback"
                      >
                        Please Enter your PAN Number
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <div className="form-group mainForm">
                      <label htmlFor="" className="txtLabel">
                        What is your Contact number ?
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleFormControlInput6"
                        placeholder="Enter Contact number"
                        name="contactNo"
                        value={
                          entityDetails.contactNo ? entityDetails.contactNo : ""
                        }
                        onChange={onChangeHandler}
                        required
                      />
                      <div
                        style={{ fontSize: "14px" }}
                        className="invalid-feedback"
                      >
                        Please Enter your Contact Number
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <div className="form-group mainForm">
                      <label htmlFor="" className="txtLabel">
                        Company / Organization Logo
                      </label>
                      <label htmlFor="fileSelector" className="fileLabel">
                        {entityDetails.compLogo ? (
                          <label
                            htmlFor="exampleFormControlInput7"
                            className="form-label belowLabel"
                          // style={{color : "#ac4242"}}
                          >
                            {typeof entityDetails.compLogo === "string"
                              ? entityDetails.compLogo.split("/")[4]
                              : entityDetails.compLogo.name}
                          </label>
                        ) : (
                          "Browse Files..."
                        )}
                        <input
                          type="file"
                          className="form-control d-none"
                          id="fileSelector"
                          name="CompanyLogo"
                          onChange={(e) => {
                            setEntityDetails({
                              ...entityDetails,
                              compLogo: e.target.files[0],
                            });
                          }}
                        />
                        <div
                          style={{ fontSize: "14px" }}
                          className="invalid-feedback"
                        >
                          Please Uplode company/organization logo
                        </div>
                      </label>
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <div className="form-group mainForm">
                      <label htmlFor="" className="txtLabel">
                        Have your Signature?
                      </label>
                      <label htmlFor="fileSelector1" className="fileLabel">
                        {entityDetails.signature ? (
                          <label
                            htmlFor="exampleFormControlInput9"
                            className="form-label belowLabel"
                          >
                            {typeof entityDetails.signature === "string"
                              ? entityDetails.signature.split("/")[4]
                              : entityDetails.signature.name}
                          </label>
                        ) : (
                          " Browse Files..."
                        )}
                        <input
                          type="file"
                          className="form-control d-none"
                          id="fileSelector1"
                          placeholder="Enter your GST No"
                          onChange={(e) => {
                            setEntityDetails({
                              ...entityDetails,
                              signature: e.target.files[0],
                            });
                          }}
                        />
                      </label>
                    </div>
                  </div>

                  <div className="col-md-6 col-sm-12">
                    <div className="form-group mainForm">
                      <label htmlFor="" className="txtLabel">
                        Bank Details
                      </label>
                      <textarea
                        rows="3"
                        className="form-control"
                        placeholder="Please enter your bank details..."
                        name="bankDetails"
                        value={
                          entityDetails?.bankDetails
                            ? entityDetails?.bankDetails
                            : ""
                        }
                        onChange={onChangeHandler}
                        required
                      ></textarea>
                      <div
                        style={{ fontSize: "14px" }}
                        className="invalid-feedback"
                      >
                        Please Enter Bank Details
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <div className="form-group mainForm">
                      <label htmlFor="" className="txtLabel">
                        City
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleFormControlInput2"
                        placeholder="Enter your city"
                        name="city"
                        value={entityDetails.city ? entityDetails.city : ""}
                        onChange={onChangeHandler}
                        required
                      />
                      <div
                        style={{ fontSize: "14px" }}
                        className="invalid-feedback"
                      >
                        Please Enter your city
                      </div>
                    </div>

                    <div className="form-group mainForm">
                      <label htmlFor="" className="txtLabel">
                        PinCode
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="exampleFormControlInput2"
                        placeholder="Enter your PinCode"
                        name="pinCode"
                        value={
                          entityDetails.pinCode ? entityDetails.pinCode : ""
                        }
                        onChange={onChangeHandler}
                        required
                      />
                      <div
                        style={{ fontSize: "14px" }}
                        className="invalid-feedback"
                      >
                        Please Enter your PinCode
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 col-sm-12">
                    <div className="form-group mainForm">
                      <label htmlFor="" className="txtLabel">
                        Address
                      </label>
                      <textarea
                        rows="4"
                        className="form-control"
                        placeholder="Address..."
                        name="address"
                        value={
                          entityDetails.address ? entityDetails.address : ""
                        }
                        onChange={onChangeHandler}
                        required
                      ></textarea>
                      <div
                        style={{ fontSize: "14px" }}
                        className="invalid-feedback"
                      >
                        Please Enter Business Address
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-md-6 col-sm-12">
                    
                  </div> */}

                  {/* <p></p> */}
                  <div className="col-md-6 col-sm-12">
                    <div className="form-group mainForm">
                      <label htmlFor="" className="txtLabel">
                        Additional Address
                      </label>
                      <textarea
                        rows="4"
                        className="form-control"
                        placeholder="Additional Address"
                        name="additionalAddress"
                        value={
                          entityDetails.additionalAddress
                            ? entityDetails.additionalAddress
                            : ""
                        }
                        onChange={onChangeHandler}
                      ></textarea>
                      <div
                        style={{ fontSize: "14px" }}
                        className="invalid-feedback"
                      >
                        Please Enter Additional Address
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <div className="form-group mainForm">
                      <label htmlFor="" className="txtLabel">
                        Terms & Condition / Disclaimers
                      </label>
                      <textarea
                        rows="6"
                        className="form-control"
                        placeholder="Start writing here..."
                        name="terms"
                        maxLength={250}
                        value={entityDetails.terms ? entityDetails.terms : ""}
                        onChange={onChangeHandler}
                      ></textarea>
                    </div>
                    <div className="countBox text-end">
                      <span
                        className={isCountFulfiled ? "redCount" : "spanCount"}
                      >
                        Character's Limit : {entityDetails.terms.length} of{" "}
                        <span>250</span>{" "}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-lg-12 text-end responiWidth">
                  <button
                    type="button"
                    className="cancel-btn"
                    onClick={(e) => {
                      e.preventDefault();
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    className="save-btn  pl-2 pr-2"
                    id="widthauto"
                    type="submit"
                  >
                    Save
                  </button>
                </div>
              </Form>
            </div>
          </div>
          {/* ========================================= PROFILE SETTINGS ========================================= */}

          {/* ========================================= FINANCIAL YEAR SETTINGS ========================================= */}

          <div className="mainCard">
            <div className="cardHead">
              <label htmlFor="">Financial Year Settings</label>
              {/* <div className="financial-year-add-btn"> */}
              {/* <div className="row-end"> */}
              <button type="button" onClick={() => setYearModalOpen(true)}>
                Add +
              </button>
              {/* </div> */}
              {/* </div> */}
            </div>
            <div className="cardBody">
              <div className="row mb-2 ">
                <div className="financial-year-list-table">
                  {financialYearList && financialYearList.length > 0 && (
                    <table class="year-listing-table">
                      <thead>
                        <tr>
                          <th className="left-align">Sr. No.</th>
                          <th>Name</th>
                          <th>From Date</th>
                          <th>To Date</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {financialYearList.map((item, idx) => {
                          return (
                            <tr key={"financialYearList" + idx}>
                              <td>{idx + 1}</td>
                              <td>{item?.name}</td>
                              <td>
                                {moment(item?.startDate).format("DD-MM-YYYY")}
                              </td>
                              <td>
                                {moment(item?.endDate).format("DD-MM-YYYY")}
                              </td>
                              <td>
                                <img
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    setYearModalOpen(true);
                                    setExistingData({
                                      name: item?.name,
                                      startDate: item?.startDate,
                                      endDate: item?.endDate,
                                      isCurrentYear: item?.isCurrentYear,
                                      financialYearId: item?.financialYearId,
                                    });
                                  }}
                                  // src={editIcon}
                                  src={""}
                                />
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  )}
                </div>

                {/* <div className="col-md-6 col-sm-12">
                    <div className="form-group mainForm">
                      <div className="justify-content-between d-flex">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <label htmlFor="" className="txtLabel">
                            Financial Year Name
                          </label>
                        </div>
                      </div>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter your email address"
                        // value={
                        //   einvioceData.username ? einvioceData.username : ""
                        // }
                        name="year"
                        // onChange={(e) => {
                        //   setEinvioceData({
                        //     ...einvioceData,
                        //     username: e.target.value,
                        //   });
                        // }}
                      />
                      <div className="invalid-feedback">
                        Financial year name is required
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 col-sm-12">
                    <div className="form-group mainForm">
                      <label htmlFor="" className="txtLabel">
                        From Date
                      </label>
                      <DatePicker
                        selected={
                          financialYearData.startDate
                            ? new Date(financialYearData.startDate)
                            : new Date()
                        }
                        value={
                          financialYearData.startDate
                            ? displayDateFormat(
                                appSettings.dateFormat,
                                financialYearData.startDate
                              )
                            : new Date()
                        }
                        onChange={(date) => {
                          // console.log("date,", new Date(date)
                          // .toISOString()
                          // .toString())
                          // console.log("ou,", displayDateFormat(
                          //   appSettings.dateFormat,
                          //   financialYearData.startDate
                          // ))
                          setFinancialYearData({
                            ...financialYearData,
                            startDate: new Date(date).toISOString().toString(),
                          });
                        }}
                        showYearDropdown
                        required
                        // dateFormat={"dd/MM/yyyy"}
                        name="invoiceDate"
                        placeholderText="Choose a date"
                        className="form-control"
                      />
                      <div className="invalid-feedback">
                        From date is required
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6 col-sm-12">
                    <div className="form-group mainForm">
                      <label htmlFor="" className="txtLabel">
                        To Date
                      </label>
                      <DatePicker
                        selected={
                          financialYearData.endDate
                            ? new Date(financialYearData.endDate)
                            : new Date()
                        }
                        value={
                          financialYearData.endDate
                            ? displayDateFormat(
                                appSettings.dateFormat,
                                financialYearData.endDate
                              )
                            : new Date()
                        }
                        onChange={(date) => {
                          setFinancialYearData({
                            ...financialYearData,
                            endDate: new Date(date).toISOString().toString(),
                          });
                        }}
                        showYearDropdown
                        required
                        // dateFormat={"dd/MM/yyyy"}
                        name="invoiceDate"
                        placeholderText="Choose a date"
                        className="form-control "
                      />
                      <div className="invalid-feedback">
                        To date is required
                      </div>
                    </div>
                  </div> */}
              </div>
            </div>
          </div>
          {/* ========================================= FINANCIAL YEAR SETTINGS ========================================= */}
          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={yearModalOpen}
            onHide={() => {
              setYearModalOpen(false);
              setExistingData({
                name: "",
                startDate: "",
                endDate: "",
                isCurrentYear: false,
                financialYearId: "",
              });
            }}
          >
            <Formik
              initialValues={{
                name: existingData.name || "",
                startDate: existingData.startDate || "",
                endDate: existingData.endDate || "",
                isCurrentYear: existingData.isCurrentYear || false,
                financialYearId: existingData.financialYearId || "",
              }}
              validate={(values) => {
                const errors = {};
                if (!values.name) {
                  errors.name = "Financial year name is required";
                }
                if (!values.startDate) {
                  errors.startDate = "From date is required";
                }
                if (!values.endDate) {
                  errors.endDate = "To date is required";
                }
                return errors;
              }}
              onSubmit={async (values, { setSubmitting }) => {
                try {
                  const apiCall = values.financialYearId ? put : post;
                  const res = await apiCall(
                    ApiConfig.FETCH_FINANCIAL_YEAR_LIST,
                    values
                  );
                  const { success, statusCode, message } = res;
                  if (statusCode === 200 && success) {
                    notifySuccess(message);
                    setYearModalOpen(false);
                    setBackDropOpen(true);
                    fetchYearList();
                    setExistingData({
                      name: "",
                      startDate: "",
                      endDate: "",
                      isCurrentYear: false,
                      financialYearId: "",
                    });
                  }
                } catch (error) {
                  console.error("catch error", error);
                } finally {
                  setSubmitting(false);
                  setBackDropOpen(false);
                }
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
              }) => {
                return (
                  <form onSubmit={handleSubmit}>
                    <Modal.Header closeButton>
                      <Modal.Title id="contained-modal-title-vcenter">
                        Add Financial Year
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <div className="financial-form">
                        <div className="financial-year-main-section">
                          <div className="text-start">
                            <input
                              type="checkbox"
                              className="me-2 mb-3"
                              checked={values?.isCurrentYear}
                              name="isCurrentYear"
                              onChange={handleChange}
                            />
                            <label>Set as default financial year</label>
                          </div>
                          <div className="row mb-3">
                            <div className="col-md-6 col-sm-12">
                              <div className="form-group mainForm">
                                <div className="justify-content-between d-flex">
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <label htmlFor="" className="txtLabel mb-2">
                                      Financial Year Name
                                    </label>
                                  </div>
                                </div>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter your financial year name"
                                  name="name"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.name}
                                />
                                {errors.name && touched.name && (
                                  <div className="invalid-error">
                                    {errors.name}
                                  </div>
                                )}
                                {/* <div className="invalid-feedback">
                                Financial year name is required
                              </div> */}
                              </div>
                            </div>
                            <div className="col-md-6 col-sm-12">
                              <div className="form-group mainForm">
                                <label htmlFor="" className="txtLabel mb-2">
                                  From Date
                                </label>
                                <div>
                                  <input
                                    type="date"
                                    className="form-control"
                                    name="startDate"
                                    value={
                                      values.startDate
                                        ? moment(values.startDate).format(
                                          "YYYY-MM-DD"
                                        )
                                        : ""
                                    }
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                  />
                                  {errors.startDate && touched.startDate && (
                                    <div className="invalid-error">
                                      {errors.startDate}
                                    </div>
                                  )}
                                </div>
                                {/* <div className="invalid-feedback">
                                  From date is required
                                </div> */}
                              </div>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-6 col-sm-12">
                              <div className="form-group mainForm">
                                <label htmlFor="" className="txtLabel mb-2">
                                  To Date
                                </label>
                                <div>
                                  <input
                                    type="date"
                                    className="form-control"
                                    name="endDate"
                                    value={
                                      values.endDate
                                        ? moment(values.endDate).format(
                                          "YYYY-MM-DD"
                                        )
                                        : ""
                                    }
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                  />
                                  {errors.endDate && touched.endDate && (
                                    <div className="invalid-error">
                                      {errors.endDate}
                                    </div>
                                  )}
                                </div>
                                {/* <div className="invalid-feedback">
                                  To date is required
                                </div> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Modal.Body>
                    <Modal.Footer>
                      <div className="col-lg-12 text-end responiWidth">
                        <button
                          type="button"
                          className="cancel-btn"
                          style={{
                            border: "1px solid #53b7e8",
                            borderRadius: "5px",
                            width: "140px",
                            height: "40px",
                            background: "none",
                            color: "#53b7e8",
                          }}
                          onClick={() => {
                            setYearModalOpen(false);
                            setExistingData({
                              name: "",
                              startDate: "",
                              endDate: "",
                              isCurrentYear: false,
                              financialYearId: "",
                            });
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          className="save-btn  pl-2 pr-2"
                          id="widthauto"
                          type="submit"
                          disabled={isSubmitting}
                          style={{
                            fontSize: "1rem",
                            borderRadius: "5px",
                            width: "160px",
                            height: "40px",
                            background: "#53b7e8",
                            color: "white",
                            border: "none",
                            marginLeft: "20px",
                          }}
                        >
                          Save
                        </button>
                      </div>
                    </Modal.Footer>
                  </form>
                );
              }}
            </Formik>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default Settings;
